import { ID } from '../../utils/codecUtils';

export const getHistoryExport =
  (endpoint: 'organizations' | 'organization_groups') => (id: ID) => {
    return {
      endpoint: `/${endpoint}/${id}/billing_history/export`,
      method: 'GET',
      responseType: 'blob',
    } as const;
  };
